/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../../../../store';
import { useParams } from 'react-router-dom';
import Buttons from '../../../../../../../../components/forms/Buttons';
import React, { useEffect } from 'react';
import { finaliseShipmentThunk } from '../../../../../../../../store/shipmentFinalise/thunks';
import { Loader, Message } from '@omnigenbiodata/ui';
import {
  finaliseShipmentHasErrorSelector,
  finaliseShipmentIsBusySelector,
  finaliseShipmentResponseSelector,
} from '../../../../../../../../store/shipmentFinalise/selectors';
import { Container } from '@mui/material';
import { resetFinaliseShipment } from '../../../../../../../../store/shipmentFinalise';

interface ConfirmationModalProps {
  staged: any | null;
  isOpen: boolean;
  onClose: () => void;
  t: any;
  shipmentDate: string;
}

const ConfirmationModal = ({ isOpen, onClose, staged, t, shipmentDate }: ConfirmationModalProps) => {
  const dispatch = useAppDispatch();
  const { shippingId } = useParams<any>();
  const finaliseShipmentIsBusy = useAppSelector(finaliseShipmentIsBusySelector);
  const finaliseShipmentError = useAppSelector(finaliseShipmentHasErrorSelector);
  const finaliseShipmentResponse = useAppSelector(finaliseShipmentResponseSelector);

  const onConfirm = () => {
    dispatch(
      finaliseShipmentThunk({
        shipmentId: shippingId || '',
        shippedDate: shipmentDate,
      }),
    );
  };

  useEffect(() => {
    if (finaliseShipmentResponse?.shipmentUuid) {
      dispatch(resetFinaliseShipment());
      onClose();
    }
  }, [finaliseShipmentResponse]);

  return (
    <Dialog
      open={isOpen}
      maxWidth="md"
      fullWidth
      onClose={onClose}
      aria-labelledby="shipping-confirm-modal"
      data-testid="shipping-confirm-modal"
    >
      <DialogTitle id="end-dialog-title">
        <Typography my={1} variant="h4" component="div" align="center">
          {t('createShipment.confirm.title')}
        </Typography>
        <Typography variant="body1" align="center">
          {t('createShipment.confirm.text', {
            sampleTotal: staged ? staged.totalAliquotCount : 0,
            boxTotal: staged ? staged.cryoboxes.length : 0,
          })}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Container maxWidth="sm">
          {finaliseShipmentError.hasError && <Message severity="error">{finaliseShipmentError.message}</Message>}
        </Container>
        <Loader isVisible={finaliseShipmentIsBusy} label={t('loaders.shipping')} />
      </DialogContent>
      <DialogActions>
        <Box px={2} pb={2} width="100%">
          <Buttons
            forwardLabel={t('buttons.confirm')}
            onForward={onConfirm}
            onBack={onClose}
            backLabel={t('buttons.back')}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
